import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermosCondicoes() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="mb-8">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Voltar ao início</span>
            </Link>
          </div>

          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl">
                <i className="ri-file-list-3-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Termos e Condições de Utilização</h1>
                <p className="text-gray-500 text-sm mt-1">Última atualização: Janeiro 2025</p>
              </div>
            </div>

            <div className="bg-teal-50 rounded-xl p-6 mb-8">
              <p className="text-gray-700 leading-relaxed">
                Bem-vindo(a) ao site <strong>www.consultadoriadesaude.com</strong>. Ao aceder e utilizar este site/aplicação, 
                está a concordar com os presentes Termos e Condições. Recomendamos que leia atentamente este documento antes 
                de continuar a navegar ou utilizar os nossos serviços.
              </p>
            </div>

            <div className="prose prose-gray max-w-none">
              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-building-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Identificação do Responsável</h2>
                    <p className="text-gray-600 leading-relaxed mb-4">Este site é gerido por:</p>
                    <div className="bg-gray-50 rounded-xl p-5 space-y-2">
                      <p className="text-gray-700"><strong>Nome da empresa:</strong> Article Land, Lda</p>
                      <p className="text-gray-700"><strong>NIF/NIPC:</strong> 510968813</p>
                      <p className="text-gray-700"><strong>Sede:</strong> Travessa José Maria da Costa, número 7, 1 esquerdo, 1495-723 Dafundo – Cruz Quebrada</p>
                      <p className="text-gray-700"><strong>Escritório:</strong> Rua Actor Francisco Ribeiro, número 1, 2795-086 Dafundo</p>
                      <p className="text-gray-700"><strong>Email:</strong> geral@articleland.pt</p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Aceitação dos Termos</h2>
                    <p className="text-gray-600 leading-relaxed">
                      Ao utilizar este site, declara que leu, compreendeu e aceitou estes Termos e Condições. 
                      Caso não concorde com algum dos pontos, por favor, não utilize os nossos serviços.
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-service-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Serviços Prestados</h2>
                    <p className="text-gray-600 leading-relaxed mb-4">Através deste site, disponibilizamos:</p>
                    <div className="grid md:grid-cols-2 gap-3">
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Implementação Chave-na-mão</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Procedimentos Legais</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Projetos de Arquitetura</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Formação de Equipas</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Criação e Comunicação de Marca</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Comunicação Digital</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Suporte Jurídico</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Assessoria de Imprensa</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Gestão de Crise</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-blank-circle-fill text-teal-500 text-xs mt-2"></i>
                        <span className="text-gray-600">Formação de Porta-vozes (Media Training)</span>
                      </div>
                    </div>
                    <p className="text-gray-600 leading-relaxed mt-4">
                      Reservamo-nos o direito de modificar, suspender ou descontinuar qualquer parte do serviço a qualquer momento, sem aviso prévio.
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-copyright-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Propriedade Intelectual</h2>
                    <p className="text-gray-600 leading-relaxed">
                      Todos os conteúdos disponíveis neste site (textos, imagens, logótipos, vídeos, design, entre outros) 
                      são propriedade da Consultadoria de Serviços em Saúde SA / Article Land, Lda ou utilizados com 
                      autorização legal. A sua reprodução, distribuição ou utilização indevida é estritamente proibida 
                      sem autorização prévia por escrito.
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-shield-user-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Dados Pessoais</h2>
                    <p className="text-gray-600 leading-relaxed">
                      A utilização deste site pode implicar o fornecimento de dados pessoais. O tratamento desses dados 
                      é regido pela nossa <Link to="/politica-privacidade" className="text-teal-600 hover:text-teal-700 font-medium cursor-pointer">Política de Privacidade</Link>, 
                      em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD).
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-user-settings-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Responsabilidade do Utilizador</h2>
                    <p className="text-gray-600 leading-relaxed mb-4">O utilizador compromete-se a:</p>
                    <ul className="space-y-2 text-gray-600">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-500 mt-1"></i>
                        <span>Utilizar o site de forma responsável e legal</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-500 mt-1"></i>
                        <span>Não introduzir vírus, malware ou outro código prejudicial</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-500 mt-1"></i>
                        <span>Não recolher dados de outros utilizadores</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-500 mt-1"></i>
                        <span>Não tentar aceder a áreas protegidas sem autorização</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-shield-check-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Limitação de Responsabilidade</h2>
                    <p className="text-gray-600 leading-relaxed mb-4">Não nos responsabilizamos por:</p>
                    <ul className="space-y-2 text-gray-600">
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-red-500 mt-1"></i>
                        <span>Danos causados por uso indevido do site</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-red-500 mt-1"></i>
                        <span>Interrupções ou falhas temporárias do serviço</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-red-500 mt-1"></i>
                        <span>Conteúdos de sites externos eventualmente referenciados</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-edit-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Modificações aos Termos</h2>
                    <p className="text-gray-600 leading-relaxed">
                      Estes Termos e Condições podem ser alterados a qualquer momento. As alterações entram em vigor 
                      assim que publicadas no site. Recomendamos a consulta regular deste documento.
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-scales-3-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Lei Aplicável</h2>
                    <p className="text-gray-600 leading-relaxed">
                      Os presentes termos são regidos pela legislação portuguesa e, em caso de litígio, será competente 
                      o foro da comarca de Lisboa.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-customer-service-2-line text-teal-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Contactos</h2>
                    <p className="text-gray-600 leading-relaxed mb-4">
                      Para qualquer questão relacionada com estes Termos, pode contactar-nos:
                    </p>
                    <div className="bg-teal-50 rounded-xl p-6">
                      <div className="flex flex-col gap-3">
                        <a 
                          href="mailto:geral@articleland.pt" 
                          className="flex items-center gap-3 text-teal-700 hover:text-teal-800 transition-colors cursor-pointer"
                        >
                          <i className="ri-mail-line text-xl"></i>
                          <span>geral@articleland.pt</span>
                        </a>
                        <a 
                          href="mailto:consultadoriaeservicosemsaude@gmail.com" 
                          className="flex items-center gap-3 text-teal-700 hover:text-teal-800 transition-colors cursor-pointer"
                        >
                          <i className="ri-mail-line text-xl"></i>
                          <span>consultadoriaeservicosemsaude@gmail.com</span>
                        </a>
                        <a 
                          href="tel:+351919214659" 
                          className="flex items-center gap-3 text-teal-700 hover:text-teal-800 transition-colors cursor-pointer"
                        >
                          <i className="ri-phone-line text-xl"></i>
                          <span>+351 919 214 659</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <Link 
              to="/politica-privacidade" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-xl shadow-sm hover:shadow-md transition-all text-gray-700 hover:text-teal-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shield-user-line"></i>
              <span>Política de Privacidade</span>
            </Link>
            <Link 
              to="/politica-cookies" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-xl shadow-sm hover:shadow-md transition-all text-gray-700 hover:text-teal-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-cookie-line"></i>
              <span>Política de Cookies</span>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
